import React from 'react';
import ReactSWF from 'react-swf';

const PlayNow = (props) => {
    switch (props.playNow.type) {
    case 'flash':
        return <ReactSWF 
            src={props.playNow.url} 
            width={props.playNow.width} 
            height={props.playNow.height} 
            wmode='direct'>
        </ReactSWF>;
    default:
        return null;
    }
};

export default PlayNow;


// WEBPACK FOOTER //
// ./src/components/GameInfo/PlayNow.js